<template>
    <transition v-if="open" name="modal">
        <div class="modal-mask">
            <div @click.self="toggle" class="modal-wrapper">
                <div class="modal-container rounded" ref="modalContainer">
                    <div class="modal-header">
                        <h3 class="heading-text flex-grow">{{ heading }}</h3>

                        <button v-if="timesButton" class="button small-rounded" @click="toggle">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        heading: {
            type: String,
            default: null
        },
        timesButton: {
            type: Boolean,
            default: true
        },
        open: {
            type: Boolean,
            default: false
        },
        staticBackdrop: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // open: false
        }
    },
    mounted() {
        window.addEventListener("keyup", this.onEscapeKeyUp);
    },
    beforeDestroy() {
        window.removeEventListener("keyup", this.onEscapeKeyUp);
    },
    methods: {
        toggle() {
            if (this.staticBackdrop) {
                return;
            }
            this.open = !this.open
        },
        onEscapeKeyUp(event) {
            if (event.which === 27) {
                this.$emit("close");
            }
        }
    }
}
</script>

<style lang="scss">
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: table;
    transition: opacity 0.3s ease;

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;

        .modal-container {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
            background: rgba(255, 255, 255, 0.75);
            transition: all 0.3s ease;
            max-width: 800px;
            width: unset;
            margin: 80px auto;
            padding: 12px;

            .modal-header {
                display: flex;
                gap: 1rem;
                align-items: center;
                justify-content: space-between;

                h3 {
                    margin-top: 0;
                    color: #1d941a;
                }
            }

            .modal-body {
                margin: 20px 0;
                max-height: 700px;
            }
        }
    }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>